import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


import * as vars from '../../constants/variables';

import { getCountries } from "../../actions/CountryActions";

import { console_log } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';

class CountryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countriesArray: {},
            all: false
        };
        this.selectAllCountries = this.selectAllCountries.bind(this);
        this.selectCountries = this.selectCountries.bind(this);
        this.mapCountryDomain = this.mapCountryDomain.bind(this);
        this.modalToggle = this.modalToggle.bind(this);
    }
    componentWillMount() {
        this.getCountries();
    }

    componentDidMount() {
        let countriesArray = [];
        if (this.props.country.countries.length > 0) {
            this.props.country.countries.map(v => {
                countriesArray[v.countryId] = false;
            });
        }

        this.setState({
            countriesArray: countriesArray
        })
    }

    componentWillReceiveProps(nextProps) {
        let countriesArray = this.state.countriesArray,
            all = false;
        if (countriesArray.length > 0) {
            countriesArray.map((v, k) => {
                if (nextProps.countries.indexOf(k) !== -1) {
                    countriesArray[k] = true;
                } else {
                    countriesArray[k] = false;
                }
            });
        }

        if (this.state.countriesArray.length-1 === countriesArray.filter((v) => ( v === true)).length) {
            all = true;
        }

        this.setState({
            countriesArray: countriesArray,
            all: all
        });
    }

    getCountries() {
        axios.get(vars.BASE_URL+'/getCountries')
            .then((response) => {
                if (response.data.success) {
                    this.props.getCountries(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
            })
    }

    selectAllCountries(e) {
        let countriesArray = this.state.countriesArray;
        if (countriesArray.length > 0) {
            countriesArray.forEach((v, k) => {
                countriesArray[k] = !this.state.all;
            })
        }

        this.setState({
            countriesArray: countriesArray,
            all: !this.state.all
        });
    }

    selectCountries(countryId, e) {
        let countriesArray = this.state.countriesArray,
            all = false;
        countriesArray[countryId] = e.target.checked;

        if (this.state.countriesArray.length-1 === countriesArray.filter((v) => ( v === true)).length) {
            all = true;
        }
        this.setState({
            countriesArray: countriesArray,
            all: all
        });
    }

    mapCountryDomain() {
        let countriesArray = this.state.countriesArray,
            data = [];

        countriesArray.forEach((v, k) => {
            if (v) {
                data.push({
                    domainId: this.props.domainId,
                    countryId: k
                })
            }
        });

        this.props.mapCountryDomain(data);
        this.modalToggle();
    }

    modalToggle() {
        this.props.modalToggle({
            domainId: 0,
            countries: []
        });
    }

    render() {
        // console_log(this.props.countries);
        return (
            <Modal isOpen={this.props.show} toggle={this.modalToggle} className='modal-lg'>
                <ModalHeader toggle={this.modalToggle}>Edit Domain</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs={3} md={3}>
                            <Label check htmlFor="country-all">
                                <Input type="checkbox" id="country-all" checked={this.state.all} name="country-all" value="all" onChange={this.selectAllCountries}/> All
                            </Label>
                        </Col>
                    </Row>
                    <Row>
                        {(this.props.country.countries) ?
                            this.props.country.countries.map((country, key) => {
                                return (
                                    <Col key={country.countryId} xs={3} md={3}>
                                        <Label check htmlFor={country.countryId}>
                                            <Input className="country" type="checkbox"
                                                   id={country.countryId}
                                                   name={country.countryId}
                                                   value={country.countryId}
                                                   checked={this.state.countriesArray[country.countryId]}
                                                   onChange={this.selectCountries.bind(this, country.countryId)} /> {country.name} ({country.code})
                                        </Label>
                                    </Col>
                                )
                            })
                            : ''}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={this.modalToggle}>
                        <FormattedMessage id="cancel"
                            defaultMessage="Cancel"
                        />
                    </Button>{' '}
                    <Button color="success" onClick={this.mapCountryDomain}>
                        <FormattedMessage id="save"
                            defaultMessage=" Save"
                        />
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getCountries
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryModal);


// WEBPACK FOOTER //
// ./src/components/CountryModal/CountryModal.js